import React from 'react';
import { FieldDisplayProps } from '../../types';

export const NumberFieldDisplay: React.FC<FieldDisplayProps> = ({
  value,
  onStartEditing,
  isReadOnly,
}) => {
  const handleClick = () => {
    if (!isReadOnly) {
      onStartEditing();
    }
  };

  if (!value) {
    return (
      <div
        className="pill custom-field-pill editable empty-placeholder"
        onClick={handleClick}
      />
    );
  }

  // Format number for display
  let displayValue = value;
  const num = parseFloat(value);
  if (!isNaN(num)) {
    displayValue = num.toLocaleString();
  }

  return (
    <div
      className="pill custom-field-pill editable"
      onDoubleClick={handleClick}
      onClick={handleClick}
    >
      {displayValue}
    </div>
  );
};

export default NumberFieldDisplay;
